import Vue from 'vue'
const CryptoJS = require("crypto-js")

//回调函数的xhr请求
export function communicate(apiurl, postData, cb) {
  postData.head.auth = globalstore.state.user.auth
  postData.head.auth2 = globalstore.state.user.auth2

  postData.head.auth = head.auth
  postData.head.auth2 = head.auth2
  Vue.prototype.$axios.post(apiurl, postData).then(
    (res) => {
      // console.log(55)
      cb && cb(res)
    },
    (err) => {
      console.log(err)
    }
  )
}

//promise方式的xhr请求
export function httpPromise(apiurl, postData, cb) {
  postData.head.auth = globalstore.state.user.auth
  postData.head.auth2 = globalstore.state.user.auth2

  postData.head.auth = head.auth
  postData.head.auth2 = head.auth2

  return new Promise((resolve, reject) => {
    Vue.prototype.$axios.post(apiurl, postData).then(
      (res) => {
        resolve(res)
      },
      (err) => {
        $.alert('请求错误')
      }
    )
  })
}

export function get(data) {
  var click_img = new Image()

  var baseUrl = Global_apiserver + '/api/csco/clickstream'

  var result = ''
  for (let k in data) {
    result += k + '=' + data[k] + '&'
  }

  result = baseUrl + '?' + result.substr(0, result.length - 1)

  // console.log(result)

  click_img.src = result
}

// 美化时间
export const goodTime = (str) => {
  let now = new Date().getTime()
  // let oldTime = new Date(str).getTime()
  let oldTime = str * 1000
  let difference = now - oldTime
  let result = ''
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  // let halfamonth = day * 15
  let month = day * 30
  let year = month * 12

  let _year = difference / year
  let _month = difference / month
  let _week = difference / (7 * day)
  let _day = difference / day
  let _hour = difference / hour
  let _min = difference / minute

  if (_year >= 1) {
    result = ~~_year + ' 年前'
  } else if (_month >= 1) {
    result = ~~_month + ' 月前'
  } else if (_week >= 1) {
    result = ~~_week + ' 周前'
  } else if (_day >= 1) {
    result = ~~_day + ' 天前'
  } else if (_hour >= 1) {
    result = ~~_hour + ' 小时前'
  } else if (_min >= 1) {
    result = ~~_min + ' 分钟前'
  } else result = '刚刚'
  return result
}


export const formatTime = (t, fmt, idAddZero = true) => {
  /**
   * t: 传入的元数据
   * fmt： 格式化的时间格式，EE: 显示周几，EEE：显示星期几
   * idAddZero: 是否需要在末尾添加  000
   */
  if (!t) return undefined;
  if (typeof t == 'string' &&  t.includes('-')) t = t.replace(/-/g, '/');
  let time = idAddZero ? new Date(t * 1000) : new Date(t);
  let o = {
    "M+": time.getMonth() + 1, // 月份
    "d+": time.getDate(), // 日
    "h+": time.getHours() % 12 === 0 ? 12 : time.getHours() % 12, // 小时
    "H+": time.getHours(), // 小时
    "m+": time.getMinutes(), // 分
    "s+": time.getSeconds(), // 秒
    "q+": Math.floor((time.getMonth() + 3) / 3), // 季度
    S: time.getMilliseconds(), // 毫秒
  };
  let week = {
    "0": "天",
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六",
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (time.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? "星期" : "周") : "") +
        week[time.getDay() + ""]
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? o[k]
          : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}

export const regExp = {
  // 手机号不正确就返回   true
  mobile: str => {
    return (/^1[3456789]\d{9}$/.test(str)) ? false : true
  }
}


let status = 0;
export const supportSafeArea = () => {
  if (status !== 0) {
    // 缓存数据，只向 body 插入一次 dom 即可
    return status === 1;
  }
  const div = document.createElement('div');
  const id = 'test-check-safe-area';
  const styles = [
    'position: fixed',
    'z-index: -1',
    'height: constant(safe-area-inset-top)',
    'height: env(safe-area-inset-top)',
  ];
  div.style.cssText = styles.join(';');
  div.id = id;
  document.body.appendChild(div);
  const areaDiv = document.getElementById(id);
  if (areaDiv) {
    status = areaDiv.offsetHeight === 0 ? 1 : -1; // 该 div 的高度是否为 0
    areaDiv.parentNode && areaDiv.parentNode.removeChild(areaDiv);
  }
  return status === 1;
};

// 判定来源（wclc2024与esmo2024使用，后期不更新维护）
export const sourceType = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (/MicroMessenger/i.test(ua)) {
    if (/iphone/i.test(ua)) {
      return 'wx_iOS'
    } else if (/android/i.test(ua)) {
      return 'wx_Android'
    }
  } else {
    if (/iphone/i.test(ua)) {
      return 'Web_iOS'
    } else if (/android/i.test(ua)) {
      return 'Web_Android'
    }
  }
}

// 判定系统（wclc2024与esmo2024使用，后期不更新维护）
export const getOS = () => {
  let u = navigator.userAgent
  if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
    return 'windows'
  } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
    return 'macOS'
  } else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
    return 'iOS'
  } else if (u.match(/android/i)) {
    return 'Android'
  } else if (u.match(/Ubuntu/i)) {
    return 'Ubuntu'
  }  else if (u.match(/arkweb/i)) {
    return 'HarmonyOS'
  } else {
    return 'other'
  }
}

// 加密方法
export function encrypt(key, data) {
  // 十六位十六进制数作为密钥
  const SECRET_KEY = CryptoJS.enc.Utf8.parse(key)
  // 十六位十六进制数作为密钥偏移量
  const SECRET_IV = CryptoJS.enc.Utf8.parse('ldM&)&ldM&)&ldM&')

  if (typeof data === 'object') {
    data = JSON.stringify(data)
  } else {
    data = data.toString()
  }

  const dataHex = CryptoJS.enc.Utf8.parse(data)
  const encrypted = new CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return encrypted.toString()
}